import { takeEvery, put, StrictEffect } from 'redux-saga/effects';
import { PowerBiActions } from '../actions/powerBi';
import { GetEmbedInfoForReportResponse } from '../../lib/api/types/GetEmbedInfoForReportResponse';
import { GetPowerBIReportsResponse } from '../../lib/api/types/GetPowerBIReportsResponse';
import { AppActions } from '../actions/app';
import { getData } from './effects/getData';

export function* powerBiSaga(): Generator<StrictEffect> {
    yield takeEvery(PowerBiActions.fetchReportDescriptions, function* () {
        const response: GetPowerBIReportsResponse = yield getData<GetPowerBIReportsResponse>('/PowerBi/GetReports');
        yield put(PowerBiActions.reportDescriptionsReceived(response.powerBiReports));
        const numReports = response.powerBiReports.length;
        if (numReports === 1) {
            yield put(PowerBiActions.viewReport(response.powerBiReports[0]));
        } else if (numReports > 1) {
            yield put(AppActions.showMainMenu(true));
        }
    });
    yield takeEvery(PowerBiActions.viewReport, function* ({ payload: reportDescription }) {
        const reportId = reportDescription.id;
        const path = `/PowerBi/GetEmbedInfoForReport?reportId=${reportId}`;
        const embedInfo: GetEmbedInfoForReportResponse = yield getData<GetEmbedInfoForReportResponse>(path);

        yield put(PowerBiActions.embedInfoReceived(embedInfo));
    });
}
